import { request, type DataInfoResponse, type PagedList } from './request';
import { buildListParams } from './params';
import type { CourseCategoryDto, CourseContentDto, CourseDto } from './types';

export interface CourseListOptions {
  pageIndex?: number;
  pageSize?: number;
  /** 分类ID（0-全部） */
  cateId?: number;
  /** 医师ID（0-全部） */
  doctorId?: number;
  /** 课程类型（0-全部 1-名师课程 2-名院课程） */
  courseType?: number;
  /** 名称搜索 */
  name?: string;
}

/** 课程列表（/course/userGetCourseList，公开接口） */
export function fetchCourseList(options: CourseListOptions = {}): Promise<PagedList<CourseDto>> {
  const { pageIndex = 1, pageSize = 10, cateId = 0, doctorId = 0, courseType = 0, name = '' } = options;

  return request(
    '/course/userGetCourseList',
    buildListParams({
      pageIndex,
      pageSize,
      state: 1,
      name,
      extra: {
        doctorId,
        doctorName: '',
        courseType,
        checkState: 0,
        isOnlyMember: 0,
        courseChargeType: 0,
        courseChargeMode: 0,
        cateIdList: [],
        cateId,
        contentCheckState: 0,
        contentState: 0,
        userId: 0,
        isSendCredit: 0,
      },
    }),
  );
}

/** 课程详情（/course/userGetCourseInfo，公开接口） */
export function fetchCourseInfo(id: number): Promise<DataInfoResponse<CourseDto>> {
  return request('/course/userGetCourseInfo', { id });
}

/** 课程分类（/course/userGetCouCateList，公开接口） */
export function fetchCourseCateList(): Promise<PagedList<CourseCategoryDto>> {
  return request(
    '/course/userGetCouCateList',
    buildListParams({
      pageIndex: 1,
      pageSize: 999,
      state: 1,
      name: '',
      extra: { layer: 0, isShow: 1, parentId: 0 },
    }),
  );
}

/** 课程目录课时（/course/userGetCouContentList，公开接口） */
export function fetchCourseContentList(courseId: number): Promise<PagedList<CourseContentDto>> {
  return request(
    '/course/userGetCouContentList',
    buildListParams({
      pageIndex: 1,
      pageSize: 999,
      state: 1,
      extra: {
        courseId,
        checkState: 0,
        courseChargeType: 0,
        userId: 0,
        chapter: 0,
        section: 0,
      },
    }),
  );
}
